import apiService from '@/api/apiService';

export const deleteAdmin = async (id) => {
    const url = `/api/admin/managers/${id}`;

    return apiService.DELETE(url);
};
